import { store } from '@/store'
import { Base, ColorMap, Ability, Stance } from '@/class'

// Used for Arts, Spirit Traits, and Careers
class AbilityPackage extends Base {
  protected abilities_: Ability[] = []
  protected stances_: Stance[] = []
  protected cost_: string

  // ==========================================================
  // GETTERS
  // ==========================================================
  get Abilities() {
    return this.abilities_
  }
  get Stances() {
    return this.stances_
  }
  public get HasPrereqs() {
    return this.prereqs_ != ''
  }
  public get PrereqsHeader() {
    return '**Prerequisites:** ' + this.prereqs_
  }
  public get HasCost() {
    return this.cost_ != ''
  }
  public get Cost() {
    return this.cost_
  }
  public get CostHeader() {
    return '**Cost:** ' + this.cost_
  }
  public get Header() {
    return this.Name + ' - ' + this.Category + ' ' + this.type_
  }
  public get NamelessHeader() {
    return this.Category + ' ' + this.type_
  }
  public get HasIcon() {
    return this.Category != 'Trait'
  }
  public get Icon() {
    return require('@/assets/disciplines/' + this.Category + '.svg')
  }
  public get Color() {
    var overrideColors = ['Earth', 'Flame', 'Metal', 'Water', 'Wind', 'Wood']
    if (overrideColors.includes(this.Category)) {
      return ColorMap.get(this.Category)
    }
    if (this.Category == 'Archetype') return ColorMap.get('Archetype')
    return super.Color
  }

  // ==========================================================
  // SERIALIZATION
  // ==========================================================
  public static Deserialize(data: IAbilityPackageData): AbilityPackage {
    const t = new AbilityPackage(data.name)
    t.setAbilityPackageData(data)
    return t
  }

  public setAbilityPackageData(data: IAbilityPackageData): void {
    this.setBaseData(data)
    if (data.abilities) {
      for (var ability of data.abilities) {
        if (!ability.type && !ability.category) {
          this.abilities_.push(store.getters.getAbility(ability.name))
        } else {
          this.abilities_.push(Ability.Deserialize(ability))
        }
      }
    }
    if (data.stances) {
      for (var stance of data.stances) {
        this.stances_.push(Stance.Deserialize(stance))
      }
    }
    this.cost_ = data.cost || ''
  }
}

export default AbilityPackage
